export const SET_BROKER_LOAN_APPLICATION_ID = 'SET_BROKER_LOAN_APPLICATION_ID'
